import { MainPropertyType } from '@aloft/toolkit-shared';

import {
  VALID_CONDO_FORMS,
  VALID_MANUFACTURED_FORMS,
  VALID_MULTIFAMILY_FORMS,
  VALID_SFR_FORMS,
} from './consts.ts';

export function extractSubjectPropertyType(doc: Document): {
  propertyType: MainPropertyType;
  formType: string;
} {
  const report = doc.getElementsByTagName('REPORT');

  const formType = report[0]?.getAttribute('AppraisalFormType');

  if (!formType) {
    throw new Error('No form type found.');
  }

  if (VALID_CONDO_FORMS.includes(formType)) {
    throw new Error('Condo is not supported.');
  }

  if (VALID_SFR_FORMS.includes(formType)) {
    return {
      propertyType: 'singleFamilyResidence',
      formType,
    };
  }
  if (VALID_MANUFACTURED_FORMS.includes(formType)) {
    return {
      propertyType: 'manufacturedHome',
      formType,
    };
  }
  if (VALID_MULTIFAMILY_FORMS.includes(formType)) {
    return {
      propertyType: 'multiFamily',
      formType,
    };
  }

  throw new Error(`Invalid form type provided: ${formType}`);
}
